import { omit } from 'lodash-es';
import { fetchMetricDataGames } from '@intelligence/v3/services/topCharts';

export const fetchMobileTopChartsDataWhenSearchKeyword = async (params: any) => {
  const paramsNew: any = {
    ...omit(params || {}, ['search_by_name']),
    keyword: params?.search_by_name || '',
    use_custom_fields: ['country_abbre', 'publisher'],
  };
  const res = await fetchMetricDataGames(paramsNew);
  const resData = res?.data || {};
  const entityInfo = res?.ext?.entity_info;
  const games = resData.list || [];
  const gamesNew = games?.map((game: any) => {
    const gameId = game?.game_id || '';
    const gameEntityInfo = entityInfo?.[gameId] || {};
    return {
      ...game,
      id: gameId,
      name: game?.game_name,
      publisher_addr: game?.country_abbre || gameEntityInfo?.country_abbre || '',
    };
  });

  return { ...resData, list: gamesNew };
};
